import React from 'react';
import { SelectionMode } from '@fluentui/react';
import { GridContextProvider } from '@bingads-webui-grid/grid-context';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { perfMarkerMiddlewareFactory } from '@bingads-webui-grid/perf-marker-middleware';
import { BrandListsPageContent } from './brand-lists-page';

export const BrandListsPage = (props) => {
  const perfMarkerMiddleware = perfMarkerMiddlewareFactory(props.perfMarker, 'brand-list-page');
  const initialGridContext = {
    selectionMode: SelectionMode.multiple,
    middlewares: [perfMarkerMiddleware],
  };
  return (
    <GridContextProvider {...initialGridContext}>
      <div className="brand-lists-page">
        <BrandListsPageContent {...props} />
      </div>
    </GridContextProvider>
  );
};

BrandListsPage.propTypes = {
  perfMarker: perfMarkerPropTypes.isRequired,
};
